#!/usr/bin/env node
import yargs from 'yargs'
import { hideBin } from 'yargs/helpers'
import { json } from './index.js'

const argv = await yargs(hideBin(process.argv))
    .option('host', {
        alias: 'h',
        type: 'string',
        description: 'The host domain',
        demandOption: true
    })
    .option('public-key', {
        alias: 'p',
        type: 'string',
        description: 'The public key (multibase format)',
        demandOption: true
    })
    .help()
    .alias('help', '?')
    .parse()

console.log(json({
    host: argv.host,
    publicKey: argv.publicKey
}))
